<template>
    <section class="configuration-sign-digital">
        <div class="content-configuration">
            <div class="content-configuration-header">
                <div class="configurations-icon">
                    <em class="fal fa-cog" />
                    <span>Configurações</span>
                </div>

                <div class="configurations-right-arrow">
                    <em v-if="open" class="fal fa-chevron-down" @click="open = false" />
                    <em v-if="!open" class="fal fa-chevron-up" @click="open = true" />
                </div>
            </div>

            <div v-if="open" class="content-configuration-body">
                <div class="type-sign-digital">
                    <span class="type-sign">Tipo de Assinatura Digital</span>

                    <span class="select-integration">Selecione qual integração você deseja utilizar para assinatura digital de contratos</span>
                </div>

                <div class="select-sign-digital">
                    <ui-select-v2
                        v-model="signType"
                        :data="signTypeOptions"
                        :loading="loader.type"
                        return-value="slug"
                        item-label="name"
                        size="lg"
                        @input="typeHandler"
                        :data-ui-selected="'select-options-digital-signature'"
                        :data-ui-search="'search-digital-signature'"
                        :data-ui-options="'options-digital-signature'"
                        :data-ui-cancel-button="'cancel-option-digital-signature'"
                    />
                </div>

                <div
                    v-if="integration?.id"
                    class="authentication-configuration"
                    data-ui="modal-autenticate-digital-signature"
                >
                    <div
                        :class="{ 'error': !authenticated }"
                        class="oval"
                    />

                    <span @click="modalIntegration">
                        Configurações de Autenticação
                    </span>
                </div>
            </div>

            <div
                v-if="integration?.id && authenticated"
                class="content-configuration-sign-clone"
            >
                <div class="clone-select">
                    <span>Clonar configurações do empreendimento:</span>
                    <ui-select-v2
                        v-model="clone"
                        :data="cloneOptions"
                        :loading="loader.clone"
                        return-value="products_id"
                        item-label="name"
                        background-color="#FFF"
                        placeholder="Selecione"
                        @input="cloneHandler"
                    />
                </div>
            </div>

            <div class="content-configuration-signers">
                <div v-show="loading" class="loader-signers">
                    <ui-load-indicator
                        :h="50"
                        :stroke="8"
                        bg-color="#DFE5EC"
                        color="#69D296"
                    />
                </div>

                <router-view v-show="!loading" />
            </div>
        </div>

        <ui-modal-info
            :action="cloneConfigs"
            name="digital-sign-clone-confirm"
            title="Deseja realmente substituir as configurações atuais?"
            icon="fal fa-question-circle"
            color-circle="#FF7D00"
            btn-text="Salvar"
            btn-type="success"
            icon-circle
            footer
            can-submit
        />
    </section>
</template>

<script>
	import { uiLoadIndicator } from '@/components/ui'
    import { uiSelectV2 } from '@/components/ui/form'
    import { uiModalInfo } from '@/components/ui/modal'

    import { digitalSignature } from '@/services/axios'

    import { mapActions, mapGetters } from 'vuex'

    const defaultLoader = () => ({
        type: false,
        clone: false
    })

	export default {
		name: 'ui-digital-sign',

        props: {
            id: {
                type: [String, Number],
                required: true
            }
        },

		components: {
            uiSelectV2,
            uiLoadIndicator,
            uiModalInfo
		},

        data() {
            return {
                open: true,
                signType: '',
                signTypeOptions: [],
                clone: null,
                cloneOptions: [],
                loader: { ...defaultLoader() },
                links: [{
                    name: 'Assinatura Digital',
                    link: ``,
                    active: true,
                    legacy: true,
                    show: true
                }],
                unsubscribe: null,
                authenticated: false
            }
        },

        computed: {
            ...mapGetters('digitalSignatureStore', {
                loading: 'getLoading',
                integration: 'getIntegration',
                product: 'getProduct'
            })
        },

        created() {
            /** Subscreve para uma mutation */
            this.unsubscribe = this.$store.subscribe((mutation) => {
                // Caso a integração tenha sido removida, retorna para a view principal da Assinatura Digital
                if (mutation.type === 'digitalSignatureStore/REMOVE_INTEGRATION') {
                    this.$router.push({ name: 'products.digitalSign', params: { id: this.product?.id } })
                    this.loadData()
                }
            })

            this.loadData()
        },

        beforeDestroy() {
            this.unsubscribe()
        },

        methods: {
            ...mapActions('digitalSignatureStore', [
                'setIntegration',
                'setProduct',
                'loadCurrentProductConfigs',
                'loadProductConfigs',
                'setLoading',
                'authenticate'
            ]),
            /**
             * Carrega os dados necessários para montar o layout das integrações
             */
            loadData: async function () {
                // Verifica se foi informado um ID válido
                if (!(this.id && parseInt(this.id))) {
                    this.$toastr.e('Necessita-se informar o ID do empreendimento!')
                    this.$router.replace({ name: 'products.list' })
                    return
                }

                try {
                    this.setLoading(true)
                    this.loader.type = true
                    this.loader.clone = true

                    /**
                     * Caso o empreendimento possua uma integração configurada, busca os dados
                     * desta
                     */
                    let response = await digitalSignature.getAllV2('last-integration', { product_id: this.id })
                    const productData = { ...response.data }

                    this.setProduct(productData)

                    // Busca as opções de integração de assinatura
                    response = await digitalSignature.getAllV2('integrations')
                    this.signTypeOptions = [...response.data]

                    // Verifica o tipo de integração
                    this.signType = ''
                    if (productData?.digital_signature_integration?.id) {
                        this.signType = productData?.digital_signature_integration?.slug

                    } else {
                        /**
                         * Verifica qual rota foi acessada de modo a setar a opção correta no select de
                         * tipo de integração
                         */
                        switch (this.$route.name) {
                            case 'products.digitalSign.docuSign':
                                this.signType = 'docu_sign'
                                break

                            case 'products.digitalSign.clickSign':
                                this.signType = 'click_sign'
                                break

                            case 'products.digitalSign.onlineSign':
                                this.signType = 'assine_online'
                                break
                        }
                    }

                } catch (error) {
                    if (error?.data?.msg) this.$toastr.e(error.data.msg)
                } finally {
                    this.loader = { ...defaultLoader() }
                    this.setLoading(false)
                }
            },
            /**
             * Event handler que trata o evento de quando um tipo de assinatura digital
             * é selecionado
             */
            typeHandler: async function (value) {
                try {
                    const integration = this.signTypeOptions.find(option => option.slug === value)
                    this.setIntegration(integration)

                    // Seta a rota conforme o tipo de integração
                    let route = { name: 'products.digitalSign' }
                    switch (value) {
                        case 'docu_sign':
                            route = { name: 'products.digitalSign.docuSign' }
                            break

                        case 'click_sign':
                            route = { name: 'products.digitalSign.clickSign' }
                            break

                        case 'assine_online':
                            route = { name: 'products.digitalSign.onlineSign' }
                            break
                    }

                    if (this.$route.name !== route.name) this.$router.push(route)

                    this.loadCloneOptions()
                    this.loadCurrentProductConfigs()

                    // Verifica se a integração de assinatura está configurada
                    const response = await this.authenticate()
                    this.authenticated = response.data.data

                } catch (error) {
                    if (error?.data?.msg) this.$toastr.e(error.data.msg)
                    this.authenticated = false
                    console.log(error)
                }
            },
            /**
             * Busca as opções de empreendimentos com configurações para clonagem
             */
            loadCloneOptions() {
                if (!(this.signType && this.integration)) return

                this.loader.clone = true
                const params = {
                    integration_id: this.integration.id
                }
                return digitalSignature.getAllV2('signers', params)
                    .then(response => {
                        this.cloneOptions = [...response.data.data]
                    })
                    .catch(error => {
                        if (error?.data?.msg) this.$toastr.e(error.data.msg)
                        console.log(error)
                    })
                    .finally(() => {
                        this.loader.clone = false
                    })
            },
            /**
             * Abre o modal de configuração da integração desejada
             */
            modalIntegration() {
                let modal = ''

                switch (this.signType) {
                    case 'docu_sign':
                        modal = 'modal-open-docu-sign-integration'
                        break

                    case 'click_sign':
                        modal = 'modal-open-click-sign-integration'
                        break

                    case 'assine_online':
                        modal = 'modal-open-online-sign-integration'
                        break
                }

                if (modal) this.$root.$emit(modal)
            },
            /**
             * Event handler que trata o evento de quando se solicita a clonagem da configuração
             * de um empreendimento
             */
            cloneHandler() {
                this.$root.$emit('modal-open-digital-sign-clone-confirm')
            },
            /**
             * Carrega as configurações de assinatura para serem salvas para o empreendimento
             * selecionado
             */
            cloneConfigs() {
                this.$root.$emit('modal-close-digital-sign-clone-confirm')
                const productData = this.cloneOptions.find(option => option.products_id === this.clone)
                if (!(this.clone && productData)) return

                const payload = {
                    product_id: productData.products_id,
                    integration_id: this.integration?.id,
                    slug: this.integration?.slug
                }
                this.loadProductConfigs(payload)
            }
        }
	}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>